import type { Plugin } from 'vue';
import { useEventBus } from '@/app/core/event-bus';
import { useOnboardingHintsStore } from './stores';

export function createOnboardingHints(): Plugin {
  return {
    install() {
      const store = useOnboardingHintsStore();
      const eventBus = useEventBus();

      eventBus.on('appInitialized', async () => {
        await store.fetch();
      });
    },
  };
}

export * from './stores';
